import React from 'react'
import { Typography, Modal, Button, Icon, Row, Col } from 'antd'

const { Text, Title } = Typography
class ImageFileNewtab extends React.PureComponent {

    onClickToNewTab = () =>{
		const { typeFile, file } = this.props

        var win = window.open();
        win.document.write('<div style="margin:0 auto; width:900px; max-width:900px" align="center"><img src="'+'data:'+typeFile+';base64,'+file+'" style="height:100%"/></div>');
    }


	async componentDidMount() {
    }

	render() {
		const { typeFile, file, formUpload= false } = this.props
		return (
			<>
               {
                  formUpload ?
                     <Row  gutter={16} type="flex" justify="left" align="top" >
                        <Col span={8} style={{ display:"block"}}>
                           <div style={{ width:"100%", height: "200px", padding:"10px 55px" }} align="center" className="block-show-image-modal">
                              <img style={{ width: '100%' }} src={'data:'+typeFile+';base64,'+file} className="zoom-in"/>
                              <a onClick={()=>this.onClickToNewTab()} className="icons-delect-images">
                                 <Icon type="eye" style={{ color:"#fff" }}/>
                              </a>
                           </div>
                        </Col>
                     </Row>
                  :
                     <div className="mt-5">
                        <div className="ml-4" style={{ display:"inline-block" }}>
                              <a title='Download pdf document' className="mt-3 color-red" target="_blank" onClick={ () => this.onClickToNewTab() } style={{ textDecoration: "underline" }}>คลิกเพื่อดูเอกสาร</a>
                        </div>
                        <div className="ml-4" style={{ display:"inline-block" }}>
                           <a href={'data:'+typeFile+';base64,'+file} className="mt-3 btn-color-default btn-custom color-white px-4 py-2 " download>ดาวน์โหลดรูปภาพ</a>
                        </div>
                     </div>
               }
                {/* <img style={{ width: '100%' }} src={'data:'+typeFile+';base64,'+file} className="zoom-in"></img><br></br><br></br> */}
                
			</>
		)
	}
}

export default ImageFileNewtab